import { render, staticRenderFns } from "./account-activated.vue?vue&type=template&id=00b0238b"
import script from "./account-activated.js?vue&type=script&lang=js&external"
export * from "./account-activated.js?vue&type=script&lang=js&external"
import style0 from "./account-activated.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports